import React, { useState, useEffect } from 'react';
import styles from './css/VideoOverlay.module.css';
import { useHeroSectionsByTypePublic } from '../../hooks/herosection/useHeroSectionPublicHooks';
import Loading from '../../common/HousGlass Loader/Loading';
import { useNavigate } from 'react-router-dom';

// Helper function to limit text to a certain number of words
const limitWords = (text, limit) => {
  if (!text) return '';
  const words = text.split(' ');
  if (words.length > limit) {
    return words.slice(0, limit).join(' ') + '...';
  }
  return text;
};

function VideoOverlay() {
  const { heroSections, isLoading: isLoadingHeroSections } =
    useHeroSectionsByTypePublic("Video");
  const navigate = useNavigate();
  
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  // Check if device is mobile on component mount and window resize
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 1200); // Common breakpoint for mobile devices
    };
    
    // Initial check
    checkIfMobile();
    
    // Listen for window resize events
    window.addEventListener('resize', checkIfMobile);
    
    // Cleanup
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  // Auto rotate through hero sections
  useEffect(() => {
    if (!heroSections || heroSections.length <= 1 || !isAutoPlaying) return;
    
    const autoplayInterval = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % heroSections.length);
    }, 8000); // Change slide every 8 seconds
    
    return () => clearInterval(autoplayInterval);
  }, [heroSections, isAutoPlaying]);

  const handleThumbnailClick = (index) => {
    setCurrentIndex(index);
    // Pause autoplay when user interacts
    setIsAutoPlaying(false);
    
    // Resume autoplay after 30 seconds of inactivity
    setTimeout(() => setIsAutoPlaying(true), 30000);
  };

  // Get visible thumbnails (always show three if possible)
  const getVisibleThumbnails = () => {
    if (!heroSections || heroSections.length === 0) return [];
    return heroSections;
  };

  // Loading state
  if (isLoadingHeroSections || !heroSections || heroSections.length === 0) {
    return <div className={styles.loadingContainer}><Loading /></div>;
  }

  // Current hero section to display
  const currentHeroSection = heroSections[currentIndex];

  // Create a style object for the hero section
  const heroSectionStyle = {
    backgroundImage: `url(${currentHeroSection.computer_image})`,
    // Set the CSS variable for mobile view
    '--mobile-bg-image': `url(${currentHeroSection.mobile_image})`,
  };

  return (
    <div className={styles.container}>
      {/* Hero Section */}
      <div
        className={styles.heroSection}
        style={heroSectionStyle}
      >
        <div className={styles.overlay} />

        {/* Content */}
        <div className={styles.content}>
          <button 
            className={styles.playButton} 
            onClick={() => navigate(`/video/${currentHeroSection.video_data?.slug}`)}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 5V19L19 12L8 5Z" fill="currentColor" />
            </svg>
            Play
          </button>
        </div>

      </div>
    </div>
  );
}

export default VideoOverlay;